import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const RoundImageLoader = props => {
        return(<>
      {props.count && props.count > 0 && (
                    Array.from({ length: props.count }, (_, i) => (
            <ContentLoader 
            height={200}
            width={400}
            speed={2}
            key={i+1}
            >
            <rect x="0" y="0" rx="4" ry="4" width="100" height="12" /> 

            <circle cx="25" cy="70" r="25" /> 
            <circle cx="100" cy="70" r="25" /> 
            <circle cx="175" cy="70" r="25" /> 
            <circle cx="250" cy="70" r="25" /> 

            <circle cx="25" cy="150" r="25" />
            <circle cx="100" cy="150" r="25" />
            <circle cx="175" cy="150" r="25" />
            <circle cx="250" cy="150" r="25" />

        </ContentLoader>
                    ))
                )}</>)
    }
           
